import React from "react";
import TransactionList from "../../components/TransactionList/TransactionList";

function Program() {
  return <TransactionList />;
}

export default Program;
